import styled from "styled-components";
import useGlobalSettings from "../Provider/useGlobalSettings";
import {useState} from "react";
import {Colors} from "../Styles/Colors";

const Styles = {
	Frame: styled.div`
        padding: 20px;
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
	Title: styled.h2`
        margin: 0 0 10px 0;
        font-size: 1.2rem;
        letter-spacing: 0.08em;
        text-transform: uppercase;
    `,
	FriendItem: styled.div`
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 12px;
        padding: 12px;
        border: 1px solid ${Colors.raw.terminal_light};
        border-radius: 8px;
        background-color: rgba(255, 255, 255, 0.05);
        box-shadow:
                0 0 8px rgba(255, 255, 255, 0.15),
                0 0 16px ${Colors.raw.terminal_light};

	`,
	FriendInfo: styled.div`
        display: flex;
        flex-direction: column;
        gap: 4px;
        min-width: 0;
    `,
	FriendName: styled.div`
        font-weight: bold;
    `,
	FriendUuid: styled.div`
        font-size: 0.75rem;
        color: rgba(255, 255, 255, 0.55);
        word-break: break-all;
    `,
	DeleteButton: styled.button`
        flex-shrink: 0;
        border: 1px solid rgba(255, 80, 80, 0.8);
        border-radius: 6px;
        padding: 6px 10px;
        color: white;
        background-color: rgba(255, 0, 0, 0.25);
        cursor: pointer;

        &:hover {
            background-color: rgba(255, 0, 0, 0.45);
            box-shadow: 0 0 10px rgba(255, 80, 80, 0.7);
        }
    `,
	AddFriendForm: styled.form`
            display: flex;
            flex-direction: column;
            gap: 10px;
            padding: 12px;
            border: 1px solid rgba(255, 255, 255, 0.15);
            border-radius: 8px;
            background-color: rgba(255, 255, 255, 0.04);
        `,
	Input: styled.input`
            border: 1px solid ${Colors.raw.terminal_light};
            border-radius: 6px;
            padding: 8px 10px;
            color: white;
            background-color: rgba(0, 0, 0, 0.35);
            outline: none;

        &:focus {
            box-shadow:
                    0 0 8px rgba(255, 255, 255, 0.25),
                    0 0 16px ${Colors.raw.terminal_light};
        }
        `,
	AddButton: styled.button`
        border: 1px solid ${Colors.raw.terminal_light};
        border-radius: 6px;
        padding: 8px 10px;
        color: white;
        background-color: rgba(255, 255, 255, 0.08);
        cursor: pointer;

        &:hover {
            background-color: rgba(255, 255, 255, 0.16);
            box-shadow: 0 0 12px ${Colors.raw.terminal_light};
        }

        &:disabled {
            opacity: 0.4;
            cursor: not-allowed;
        }
        `,
	Empty: styled.div`
            padding: 14px;
            color: rgba(255, 255, 255, 0.6);
            border: 1px solid rgba(255, 255, 255, 0.15);
            border-radius: 8px;
        `,
	FriendList: styled.div`
            display: flex;
            flex-direction: column;
            gap: 10px;
			padding-top: 20px;
        `,
}

export const Friends = () => {
	const { friends, Actions } = useGlobalSettings();
	const [name, setName] = useState("");
	const [uuid, setUuid] = useState("");

	const handles = {
		addFriend: () => {
			const trimmedName = name.trim();
			const trimmedUuid = uuid.trim();

			if( !trimmedName || !trimmedUuid )
				return;

			Actions.friends.add(trimmedName, trimmedUuid);
			setName("");
			setUuid("");
		},
		deleteFriend: (uuid: string) => {
			Actions.friends.delete(uuid);
		},
	};

	return (
		<Styles.Frame>
			<Styles.AddFriendForm onSubmit={ event => {
				event.preventDefault();
				handles.addFriend();
			}}>
				<Styles.Input
					value={ uuid }
					placeholder="UUID"
					onChange={ event => setUuid(event.target.value) }
				/>
				<Styles.Input
					value={ name }
					placeholder="Name"
					onChange={ event => setName(event.target.value) }
				/>

				<Styles.AddButton
					type="submit"
					disabled={ !name.trim() || !uuid.trim() }
				>
					Freund hinzufügen
				</Styles.AddButton>
			</Styles.AddFriendForm>

			{friends.length === 0 && (
				<Styles.Empty>
					Du hast noch keine Freunde hinzugefügt.
				</Styles.Empty>
			)}

			{friends.length > 0 && (
				<Styles.FriendList>
					{friends
						.sort( (a, b) => a.name.localeCompare(b.name) )
						.map( friend => (
						<Styles.FriendItem key={ friend.uuid }>
							<Styles.FriendInfo>
								<Styles.FriendName>
									{ friend.name }
								</Styles.FriendName>

								<Styles.FriendUuid>
									{ friend.uuid }
								</Styles.FriendUuid>
							</Styles.FriendInfo>

							<Styles.DeleteButton
								type="button"
								onClick={ () => handles.deleteFriend( friend.uuid ) }
							>
								Löschen
							</Styles.DeleteButton>
						</Styles.FriendItem>
					))}
				</Styles.FriendList>
			)}
		</Styles.Frame>
	);
};